import {Inject, Injectable} from '@angular/core';
import {GeneralService} from "../general.service";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../storage.service";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TagTypeService extends GeneralService {
  businessType;
  tagRuleData$: Observable<any>;

  constructor(
    public http: HttpClient,
    private storageService: StorageService,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/tag/tagType');
    this.businessType = this.storageService.getBusinessTypeItem()
  }

  getTagCounts(recursive?) {
    let paramObject;
    if (recursive !== undefined) {
      paramObject = {
        recursive: recursive
      }
    } else {
      paramObject = {
        recursive: false
      }
    }
    return this.http.get(this.httpBase + '/tag/tag/getAllTypeTagNum', {params: paramObject}).pipe(map(res => res['data']));
  }

}
